import { defineStore } from 'pinia'

export const useModalStorePrivate = defineStore(
    'modal-store-private',
    () => {
        const modalOpen = ref(false)
        const modalTitle = ref('')
        const modalCopy = ref('')

        return {
            modalOpen,
            modalTitle,
            modalCopy
        }
    }
)

export const useModalStore = defineStore(
    'modal-store',
    () => {
        const modalStorePrivate = useModalStorePrivate()

        // Get modal state
        const modalOpen = computed(() => modalStorePrivate.modalOpen)
        const modalTitle = computed(() => modalStorePrivate.modalTitle)
        const modalCopy = computed(() => modalStorePrivate.modalCopy)

        /**
         * A function that toggles the modal open state based on the payload.
         *
         * @param {any} payload - the data to set the modal state to
         */
        const toggleModal = (payload) => {
            modalStorePrivate.modalOpen = payload

            // Remove query params if coupons popover is closed
            // Maybe refactoring to address only showModal query
            if (!payload) {
                const router = useRouter()
                router.replace({ query: {} })
            }
        }

        /**
       * A function that toggles the modal open state based on the payload.
       *
       * @param {any} payload - the data to set the modal state to
       */
        const addModalContent = (payload) => {
            modalStorePrivate.modalTitle = payload.title
            modalStorePrivate.modalCopy = payload.description
        }

        return {
            toggleModal,
            addModalContent,
            modalOpen,
            modalTitle,
            modalCopy
        }
    }
)
